import { cn } from "@/lib/utils";
import React, { ReactNode } from "react";

interface AuroraBackgroundProps extends React.HTMLProps<HTMLDivElement> {
  children?: ReactNode;
  showRadialGradient?: boolean;
}

export const AuroraBackground: React.FC<AuroraBackgroundProps> = ({
  className,
  children,
  showRadialGradient = true,
  ...props
}) => {
  return (
    <div
      className={cn("relative flex flex-col items-center justify-center transition-bg", className)}
      {...props}
    >
      <div className="absolute inset-0 overflow-hidden" style={{ filter: 'blur(5px)' }}>
        <div
          className={cn(
            `after:animate-aurora pointer-events-none absolute -inset-[40px] opacity-50
            [background-image:var(--dark-gradient),var(--aurora)]
            [background-size:300%,_200%]
            [background-attachment:fixed]
            after:content-['']
            after:absolute
            after:-inset-[40px]
            after:opacity-70
            after:[background-image:var(--dark-gradient),var(--aurora)]
            after:[background-size:200%,_100%]
            after:[background-attachment:fixed]
            after:mix-blend-difference`,
            showRadialGradient &&
              `[mask-image:radial-gradient(ellipse_at_100%_0%,black_10%,transparent_70%)]`
          )}
          style={
            {
              "--dark-gradient":
                "repeating-linear-gradient(100deg, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 7%, transparent 10%, transparent 12%, rgba(0,0,0,1) 16%)",
              "--aurora":
                "repeating-linear-gradient(100deg, #1a4a3a 10%, #2d6b5a 15%, #1a6b4a 20%, #0d3d2d 25%, #73BA9B 30%)",
            } as React.CSSProperties
          }
        />
      </div>
      {children}
    </div>
  );
};
